<template>
  <q-input
    v-model="label"
    :name="name"
    :data-vv-as="$t('label')"
    :placeholder="$t('label')"
  >
    <q-autocomplete :static-data="{ field: 'label', list: labels }" :min-characters="0"/>
  </q-input>
</template>

<script>
  import { addressing } from 'src/config'

  export default {
    props: {
      labelList: {
        type: String,
        required: true
      },

      name: {
        type: String
      }
    },

    computed: {
      label: {
        get () {
          return this.value
        },

        set (value) {
          this.$emit('input', value)
        }
      },

      labels () {
        return addressing.labels[this.labelList].map(labelKey => ({
          label: this.$t('labels')[labelKey],
          value: this.$t('labels')[labelKey]
        }))
      }
    }
  }
</script>
